import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { menuConfig } from './menuConfig';
import './Sidebar.css';

const Sidebar = () => {
    const { userData, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Use an object to track the open state of each menu by a unique ID (e.g., its title)
    const [openMenus, setOpenMenus] = useState({});

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Failed to log out', error);
        }
    };

    // Toggle the open state of a specific menu
    const toggleMenu = (menuId) => {
        setOpenMenus(prevOpenMenus => ({
            ...prevOpenMenus,
            [menuId]: !prevOpenMenus[menuId],
        }));
    };

    const role = userData?.role?.toLowerCase().replace(' ', '-') || 'default';
    const menuItems = menuConfig[role] || menuConfig.default || [];

    return (
        <div className="sidebar sidebar-style-2"> {/* Removed data-background-color="dark" to let CSS control the theme */}
            <div className="sidebar-wrapper scrollbar scrollbar-inner">
                <div className="sidebar-content">
                    <div className="user">
                        <div className="avatar avatar-online avatar-sm float-left mr-2">
                            <img 
                                src={userData?.avatar || "/static/dashboard/assets/img/avatar.png"} 
                                alt="avatar" 
                                className="avatar-img rounded-circle"
                            />
                        </div>
                        <div className="info">
                            {/* No need for a collapse mechanism on the user info */}
                            <span>
                                {userData?.username || userData?.name || 'User'}
                                <span className="user-level">balance: ₦{userData?.balance || '0.0'}</span>
                            </span>
                            <div className="clearfix"></div>
                        </div>
                    </div>

                    <ul className="nav nav-primary">
                        {menuItems.map((item, index) => {
                            const Icon = FaIcons[item.icon] || FaIcons.FaCircle;
                            const isDropdown = item.subItems && item.subItems.length > 0;
                            const menuId = item.title.toLowerCase().replace(/\s+/g, '');

                            // Check if the current dropdown menu should be open
                            const isMenuOpen = !!openMenus[menuId];

                            // Determine if the parent nav item should be marked as active
                            const isParentActive = isDropdown && item.subItems.some(sub => location.pathname === sub.path);

                            return (
                                <li key={index} className={`nav-item ${isParentActive ? 'active' : ''}`}>
                                    {isDropdown ? (
                                        <>
                                            {/* Use onClick to toggle the menu state */}
                                            <a 
                                                href="#!" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleMenu(menuId);
                                                }}
                                                aria-expanded={isMenuOpen}
                                            >
                                                <Icon />
                                                <p>{item.title}</p>
                                                <span className="caret"></span>
                                            </a>
                                            {/* Add the 'show' class based on the component's state */}
                                            <div className={`collapse ${isMenuOpen ? 'show' : ''}`} id={menuId}>
                                                <ul className="nav nav-collapse">
                                                    {item.subItems.map((subItem, subIndex) => (
                                                        <li key={subIndex}>
                                                            <NavLink to={subItem.path}>
                                                                <span className="sub-item">{subItem.title}</span>
                                                            </NavLink>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                    ) : (
                                        <NavLink to={item.path}>
                                            <Icon />
                                            <p>{item.title}</p>
                                        </NavLink>
                                    )}
                                </li>
                            );
                        })}

                        <li className="nav-item">
                            <a href="/api-docs">
                                <FaIcons.FaCode />
                                <p>Developer's API</p>
                            </a>
                        </li>

                        <li className="nav-item">
                            <a href="#!" onClick={handleLogout}>
                                <FaIcons.FaSignOutAlt />
                                <p>Logout</p>
                            </a>
                        </li>

                        <li className="nav-item">
                            <a href="/">
                                <FaIcons.FaCodeBranch />
                                <p>Version 10.1</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
